import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/common/SafeIcon';
import { useUserRole } from '../context/UserRoleContext';

const { FiShield, FiArrowLeft } = FiIcons;
let loginContextDiagnosticLogged = false;

export const Login = () => {
  const navigate = useNavigate();
  const userRoleContext = useUserRole();
  const signIn = userRoleContext?.signIn;
  const contextIsObject = userRoleContext !== null && typeof userRoleContext === 'object';

  if (!loginContextDiagnosticLogged) {
    loginContextDiagnosticLogged = true;
    console.info('[AUTH_CONTEXT_DIAG][Login]', {
      contextIsUndefined: userRoleContext === undefined,
      contextIsNull: userRoleContext === null,
      contextIsObject,
      signInType: typeof signIn,
      contextPropertyNames: contextIsObject ? Object.keys(userRoleContext).sort() : []
    });
  }

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      if (typeof signIn !== 'function') {
        throw new Error('Innloggingstjenesten er ikke tilgjengelig. Last siden på nytt.');
      }
      await signIn(email, password);
      navigate('/dashboard', { replace: true });
    } catch (failure) {
      setError(failure.message || 'Innlogging mislyktes. Kontroller opplysningene og prøv igjen.');
    } finally {
      setPassword('');
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col justify-center items-center p-4">
      <button
        onClick={() => navigate('/')}
        className="absolute top-8 left-8 flex items-center gap-2 text-slate-600 hover:text-blue-600 transition-colors font-semibold"
      >
        <SafeIcon icon={FiArrowLeft} />
        Tilbake til forsiden
      </button>

      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-2xl shadow-xl shadow-blue-200 mb-6">
            <SafeIcon icon={FiShield} className="text-3xl text-white" />
          </div>
          <h1 className="text-3xl font-black text-slate-900 tracking-tight">Velkommen til HMS-innsikt</h1>
          <p className="text-slate-500 mt-2">Logg inn for å se dine dashbord og analyser</p>
        </div>

        <div className="bg-white p-2 rounded-3xl shadow-xl shadow-slate-200/60 border border-slate-100">
          <form onSubmit={handleSubmit} className="space-y-4 p-4">
            <div>
              <label htmlFor="login-email" className="mb-2 block text-sm font-semibold text-slate-700">E-post</label>
              <input
                id="login-email"
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-600/20"
              />
            </div>
            <div>
              <label htmlFor="login-password" className="mb-2 block text-sm font-semibold text-slate-700">Passord</label>
              <input
                id="login-password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                className="w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-600/20"
              />
            </div>
            {error && <p role="alert" className="text-sm text-rose-700">{error}</p>}
            <button
              type="submit"
              disabled={submitting}
              className="w-full rounded-xl bg-blue-600 py-3 font-bold text-white transition-colors hover:bg-blue-700 disabled:opacity-60"
            >
              {submitting ? 'Logger inn …' : 'Logg inn'}
            </button>
          </form>
        </div>

        <p className="text-center mt-8 text-sm text-slate-400">
          © {new Date().getFullYear()} HMS-innsikt AS • <a href="#" className="underline">Sikkerhetsvilkår</a>
        </p>
      </div>
    </div>
  );
};

export default Login;